// Helper universal do CRM. Recebe um objeto `cliente` (com id_cliente_app,
// opcionalmente id_lead e status_lead) e devolve qual modal deve abrir e
// com quais IDs.
//
// Regras (vindas do produto):
// - sem id_lead → modal cliente
// - id_lead presente, status_lead='convertido' → modal cliente (lead virou cliente)
// - id_lead presente, qualquer outro status → modal lead
//
// O backend devolve `id_lead` e `status_lead` em qualquer cliente das rotas
// /v3/api/aawz-crm/crm-relacionamento-clientes-tasks e
// /v3/api/aawz-crm/crm-relacionamento-clientes-overview.

export const CLIENTE_MODE_LEAD = 'lead'
export const CLIENTE_MODE_CLIENTE = 'cliente'
export const LEAD_STATUS_CONVERTIDO = 'convertido'

const isPresent = (value) =>
  value !== null && value !== undefined && value !== ''

export const resolveClienteTarget = (cliente) => {
  const safe = cliente && typeof cliente === 'object' ? cliente : {}
  const idClienteApp = safe.id_cliente_app || null
  const idLead = isPresent(safe.id_lead) ? safe.id_lead : null
  const statusLead = isPresent(safe.status_lead) ? safe.status_lead : null

  if (!idLead || statusLead === LEAD_STATUS_CONVERTIDO) {
    return {
      mode: CLIENTE_MODE_CLIENTE,
      id_cliente_app: idClienteApp,
      id_lead: idLead,
      status_lead: statusLead,
    }
  }

  return {
    mode: CLIENTE_MODE_LEAD,
    id_cliente_app: idClienteApp,
    id_lead: idLead,
    status_lead: statusLead,
  }
}

// Variante para objetos de LEAD (views de leads — lista, kanban, overview).
// Leads carregam `status` (ex.: 'convertido') e, em algumas rotas, `id` no
// lugar de `id_lead`. Normaliza esses campos para o shape esperado por
// resolveClienteTarget, mantendo uma única fonte de verdade para a regra
// (lead convertido → modal cliente).
export const resolveLeadTarget = (lead) => {
  const safe = lead && typeof lead === 'object' ? lead : {}
  return resolveClienteTarget({
    id_cliente_app: safe.id_cliente_app,
    id_lead: isPresent(safe.id_lead) ? safe.id_lead : safe.id,
    status_lead: isPresent(safe.status_lead) ? safe.status_lead : safe.status,
  })
}

// Monta o `item` que os modais do CRM (crm-lead-steps e satélites) esperam a
// partir de um objeto de cliente qualquer. Existe para a regra lead × cliente
// e o ajuste de `status` terem UMA casa: antes cada consumidor de fora do CRM
// (painel de atendimento, perfil do cliente) reimplementava os dois.
//
// `idClienteApp` cobre o caso em que o id não está no próprio objeto (o painel
// de atendimento tira do contato).
export const buildLeadStepsItem = (clienteData, { idClienteApp = null } = {}) => {
  if (!clienteData) return null
  const id = idClienteApp || clienteData.id_cliente_app || clienteData.id || null
  if (!id) return null

  const target = resolveClienteTarget({
    id_cliente_app: id,
    id_lead: clienteData.id_lead,
    status_lead: clienteData.status_lead,
  })

  return {
    ...clienteData,
    mode: target.mode,
    id_lead: target.id_lead,
    id_cliente_app: id,
    // O modal de lead (botões Ganho/Perda) lê item.status como ETAPA do funil.
    // O backend manda a etapa em `status_lead` — `status` é a classificação
    // ("Prospect"/"Cliente"). Sem isso os botões de status não aparecem.
    status: target.status_lead || clienteData.status,
  }
}
